(function () {
    'use strict';

    angular
        .module('controlModule')
        .directive('grcObservation', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addObservation = '&';
        directiveScope.hideAddObservation = '&';
        directiveScope.addRecommendation = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller', 'recomConstants', 'grcObservationService', function ($rootScope, $scope, $controller, recomConstants, grcObservationService) {
                // only check permissions on boxModel if it is an Observation.
                if (!$scope.boxModel.ObservationID) {
                    $scope.boxModelPermission = null;
                }
                // set feature role if it is on object.
                if ($scope.boxModel && $scope.boxModel.RecomBusinessUnit && $scope.boxModel.RecomBusinessUnit.FeatureRole){
                    $scope.boxFeatureRole = $scope.boxModel.RecomBusinessUnit.FeatureRole;
                }

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/observation/grcObservation.[Template].tpl.html';
                // Permissions default values
                $scope.boxFeatureRole = $scope.boxFeatureRole || recomConstants.featureRoles;
                $scope.boxPermissionKey = $scope.boxPermissionKey || 'Observation'; 

                $controller('BoxTmplController', { $scope: $scope });

                $scope.hideAddObservation = $scope.hideAddObservation();
                $scope.readOnly = !$scope.boxPermissions.Edit;

            }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);

                scope.hasAddObservation = !_.isUndefined(attrs.addObservation);
            }
        }
    }
})();